export const filledIn = {
  from: '#85C9FA',
  to: '#4D66D4'
}

export const aligned = {
  from: '#FFDD32',
  to: '#FFA713'
}

export const updated = {
  from: '#BBDDEF',
  to: '#6EAFCD'
}

export const reviewed = {
  from: '#ADB7F3',
  to: '#724ACD'
}
